import React from 'react'
import styled from '@emotion/styled'
import dayjs from 'dayjs'
import { bool, number, oneOfType, string } from 'prop-types'
import { Link } from '@jelly/ui'

//styled components
const ContentWrapper = styled.div`
	display: ${({ mobileCollapse }) => (mobileCollapse === false ? 'block' : 'none')};
	margin: 10px 0;
	min-height: 125px;

	${({ theme }) => theme.MQ.M} {
		display: block;
		min-height: 150px;
		padding-bottom: 20px;
		width: 45%;
	}
`
const DateWrapper = styled.span`
	${({ theme }) => theme.text.sectionHeaderSmall};
	color: ${({ theme }) => theme.colors.navy};
	padding: 20px 0 5px 0;
	transition: all 1s ease;
`
const TitleWrapper = styled(Link)`
	${({ theme }) => theme.header.h3};
	color: #fff;
	display: block;
	margin: 0;
	padding: 10px 0;
	transition: all 1s ease;

	&:hover {
		color: ${({ theme }) => theme.colors.primary};
	}

	${({ theme }) => theme.MQ.M} {
		${({ theme }) => theme.header.h3};
		font-weight: 100;
		max-width: 100%;
		width: 100%;
	}
`

CardFeedObject.propTypes = {
	canonical: string,
	displayModified: oneOfType([string, number]),
	mobileCollapse: bool,
	title: string,
}

/**
 * This Component is the single Feed Object Card
 * It takes in Feed Object data:
 * Title, Date, Link
 * On Hover: Link goes from Orange to Navy, and date goes from Navy to Orange
 */
function CardFeedObject({ canonical, displayModified, mobileCollapse, title }) {
	return (
		<ContentWrapper mobileCollapse={mobileCollapse}>
			<DateWrapper>{dayjs(displayModified).format('MM.DD.YY')}</DateWrapper>
			<TitleWrapper href={canonical}>{title}</TitleWrapper>
		</ContentWrapper>
	)
}

export default CardFeedObject
